export default ({...props}) => {
  return `
  
  `
}

export const fieldsetWrapperStyles = () => {
  return `
    fieldset{
      @supports (-webkit-touch-callout: none) {
        width: calc(100% - 16px);
      }
    }
    fieldset:last-child {
      margin-bottom: 0px;
    }
  `
}
